import { render } from "./SettingsTabMedFrequencies.vue?vue&type=template&id=7bf396da&scoped=true"
import script from "./SettingsTabMedFrequencies.vue?vue&type=script&lang=js"
export * from "./SettingsTabMedFrequencies.vue?vue&type=script&lang=js"

import "./SettingsTabMedFrequencies.vue?vue&type=style&index=0&id=7bf396da&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf396da"]])

export default __exports__